/**
 * @generated SignedSource<<7bcbf8049ee4962be835266d14366cba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
export type WelcomeStepQuery$variables = {
  clubSlug: string;
};
export type WelcomeStepQuery$data = {
  readonly unauthenticatedClub: {
    readonly departments: ReadonlyArray<{
      readonly facilities: ReadonlyArray<{
        readonly id: string | null | undefined;
        readonly name: string;
        readonly slug: string;
      } | null | undefined> | null | undefined;
      readonly id: string | null | undefined;
      readonly type: DepartmentType;
    } | null | undefined> | null | undefined;
    readonly name: string;
  } | null | undefined;
};
export type WelcomeStepQuery = {
  response: WelcomeStepQuery$data;
  variables: WelcomeStepQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clubSlug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "clubSlug"
      }
    ],
    "concreteType": "UnauthenticatedClub",
    "kind": "LinkedField",
    "name": "unauthenticatedClub",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UnauthenticatedDepartment",
        "kind": "LinkedField",
        "name": "departments",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnauthenticatedFacility",
            "kind": "LinkedField",
            "name": "facilities",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WelcomeStepQuery",
    "selections": (v3/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WelcomeStepQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "abfd867998db61706d57efb64ac1b76b",
    "id": null,
    "metadata": {},
    "name": "WelcomeStepQuery",
    "operationKind": "query",
    "text": "query WelcomeStepQuery(\n  $clubSlug: String!\n) {\n  unauthenticatedClub(slug: $clubSlug) {\n    name\n    departments {\n      id\n      type\n      facilities {\n        id\n        name\n        slug\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "576a2dbcd970c0c032863c21fd072816";

export default node;
